<div class="tt-c-question-container">
  <div class="tt-c-question__title" v-html="question.text"></div>
  <span v-if="question.user" class="tt-o-byline__item tt-o-byline__author">{{formatUserName(question.user)}}</span>
  <time :datetime="question.dateCreated" class="tt-o-byline__item tt-o-byline__on-date">{{question.dateCreatedFormatted}}</time>
  <div v-if="question.answers && question.answers.length > 0" class="tt-c-question__answers">
    <p class="tt-c-answer__text" v-html="question.answers[0].text" style="width: 100%"></p>
    <span class="tt-o-byline__item tt-o-byline__author">{{formatUserName(question.answers[0].user)}}</span>
    <time class="tt-o-byline__item tt-o-byline__on-date">{{question.answers[0].dateCreatedFormatted}}</time>
  </div>
</div>
